module.exports = __webpack_public_path__ + "static/media/arrow.dcb34754.svg";